// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".heading[data-v-7957c4e7]{margin-block-start:18px;margin-block-end:8px;font-weight:700;color:#6a7c8f;text-transform:uppercase}.heading[data-v-7957c4e7],p[data-v-7957c4e7]{font-size:16px}.first-paragraph>p[data-v-7957c4e7]{display:inline}", ""]);
// Exports
module.exports = exports;
